export var TypeActionExpansions;
(function (TypeActionExpansions) {
    TypeActionExpansions["Select"] = "Expansions > Select";
    TypeActionExpansions["Deselect"] = "Expansions > Deselect";
    TypeActionExpansions["RequestPurchase"] = "Expansions > RequestPurchase";
    TypeActionExpansions["RequestBuyPremium"] = "Expansions > RequestBuyPremium";
    TypeActionExpansions["ConfirmBuyPremium"] = "Expansions > ConfirmBuyPremium";
    TypeActionExpansions["RequestBuyStandard"] = "Expansions > RequestBuyStandard";
    TypeActionExpansions["Highlight"] = "Expansions > Highlight";
    TypeActionExpansions["StopHighlight"] = "Expansions > StopHighlight";
})(TypeActionExpansions || (TypeActionExpansions = {}));
export var actionExpansionsSelect = function (expansionId, expansion) { return ({
    expansion: expansion,
    expansionId: expansionId,
    type: TypeActionExpansions.Select,
}); };
export var actionExpansionsDeselect = function () { return ({
    expansion: undefined,
    expansionId: -1,
    type: TypeActionExpansions.Deselect,
}); };
export var actionExpansionBuyPremium = function (expansionId, goldAmount) { return ({
    expansionId: expansionId,
    goldAmount: goldAmount,
    type: TypeActionExpansions.RequestBuyPremium,
}); };
export var actionExpansionConfirmBuyPremium = function (expansionId, goldAmount) { return ({
    expansionId: expansionId,
    goldAmount: goldAmount,
    type: TypeActionExpansions.ConfirmBuyPremium,
}); };
export var actionExpansionBuyStandard = function (expansionId, missingResources, missingCostAmount) { return ({
    expansionId: expansionId,
    missingCostAmount: missingCostAmount,
    missingResources: missingResources,
    type: TypeActionExpansions.RequestBuyStandard,
}); };
export var actionExpansionHighlight = function (expansionId) { return ({
    expansionId: expansionId,
    type: TypeActionExpansions.Highlight,
}); };
export var actionExpansionStopHighlight = function (expansionId) { return ({
    expansionId: expansionId,
    type: TypeActionExpansions.StopHighlight,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/expansions/actionExpansions.ts
// module id = 179
// module chunks = 3